module.exports = __webpack_public_path__ + "img/i-icon.b806deac.svg";